export default __webpack_public_path__ + "static/media/arrow-right-white.bc9e727a.svg";